<template>
  <div class="content-body">
    <div class="d-flex justify-content-between align-items-center w-100 mb-2">
      <h2 class="content-header-title" style="border-right: none;">{{project.short_name}} ⇝ Папки для шаблонов</h2>
      <div class="btn-group float-right" role="group">
        <button class="compose btn btn-success" @click="copyFromAnotherProject()">Скопировать из другого проекта</button>
        <button class="compose btn btn-primary" @click="newRecord()">Добавить</button>
      </div>

    </div>


    <div class="card">
      <div class="card-body h-100" style="padding: 0;">
        <div class="table-striped">
          <table class="table">
            <thead>
              <tr>
                <th style="width: 80%;">Наименование</th>
                <th style="width: 20%;">Действия</th>
              </tr>
            </thead>
            <tbody>
              <template v-if="records && records.length > 0">
                <TreeContainer @edit="editRecord($event)" @delete="deleteRecord($event)" :node="modifiedRecords" />
              </template>
              <template v-else>
                <tr>
                  <td colspan="2">
                    Нет данных для отображения
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Field Add/Edit Modal -->
    <div class="modal modal-slide-in fade" id="addNewRecord" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content pt-0">
        <div class="modal-header mb-1">
          <h5 class="modal-title" v-show="!editmode">Добавить</h5>
          <h5 class="modal-title" v-show="editmode">Редактировать</h5>
        </div>
        <form @submit.prevent="editmode ? updateRecord() : createRecord()">
            <div class="modal-body">
              <div class="form-group">
                <label>Наименование</label>
                <input v-model="recordform.name" type="text" placeholder="Наименование" class="form-control" required>
              </div>
              <div class="form-group">
                <label>Родительский каталог</label>
                <treeselect v-model="recordform.parent_id" :multiple="false" :defaultExpandLevel="3" :options="filteredRecords">
                  <label slot="option-label" slot-scope="{ node, shouldShowCount, count, labelClassName, countClassName }" :class="labelClassName">
                    {{ node.raw.name }}
                    <span v-if="shouldShowCount" :class="countClassName">({{ count }})</span>
                  </label>

                  <div slot="value-label" slot-scope="{ node }">{{ node.raw.name }}</div>
                </treeselect>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Закрыть</button>
              <button v-show="editmode" type="submit" class="btn btn-success">Обновить</button>
              <button v-show="!editmode" type="submit" class="btn btn-primary">Создать</button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- !Field Add/Edit Modal -->

    <!-- Field Add/Edit Modal -->
    <div class="modal modal-slide-in fade" id="copyForm" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content pt-0">
        <div class="modal-header mb-1">
          <h5 class="modal-title">Копирование из другого проекта</h5>
        </div>
        <form @submit.prevent="copyRecord()">
            <div class="modal-body">
              <div class="form-group">
                <label>Выберите проект</label>
                <v-select v-model="copyform.project_id" label="short_name" :reduce="project => project.id" :options="$parent.$parent.projects" />
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Закрыть</button>
              <button type="submit" class="btn btn-primary">Скопировать</button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- !Field Add/Edit Modal -->

  </div>
</template>

<script>
// import the component
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import TreeContainer from './TreeContainer'

  export default {
    components: { Treeselect, TreeContainer },
    props: ['id', 'project'],
    computed: {
      filteredRecords(){
        return this.records.filter((item) => item.parent_id === null)
      },
      modifiedRecords(){
        return {
          name: "/",
          children: this.records.filter((item) => item.parent_id === null)
        };
      }
    },
    data () {
      return {
        timeout: null,
        records: [],
        recordform: new Form({
          id: null,
          name: null,
          parent_id: null
        }),
        copyform: new Form({
          project_id: null
        }),
        editmode: false,
      }
    },
    methods: {
      copyFromAnotherProject(){
        $('#copyForm').modal('show');
      },
      copyRecord(){
        this.$Progress.start();
        this.copyform.post('/api/project/'+this.id+'/folder/copy')
        .then((response)=>{
          $('#copyForm').modal('hide');
          this.SuccessToast();
          this.loadRecords();
          this.copyform.reset();
          this.$Progress.finish();
        })
        .catch(()=>{
          this.ErrorToast();
          this.$Progress.fail();
        })
      },
      SuccessToast(){
        Toast.fire({
          icon: 'success',
          title: 'Успешно'
        });
      },
      ErrorToast(){
        Toast.fire({
          icon: 'error',
          title: 'Ошибка'
        });
      },
      editRecord(record){
        this.editmode = true;
        this.recordform.reset();
        this.recordform.id = record.id;
        this.recordform.name = record.name;
        $('#addNewRecord').modal('show');
      },
      newRecord(){
        this.editmode = false;
        this.recordform.reset();
        $('#addNewRecord').modal('show');
      },
      createRecord(){
        this.$Progress.start();
        this.recordform.post('/api/project/'+this.id+'/folder')
        .then((response)=>{
          $('#addNewRecord').modal('hide');
          this.SuccessToast();
          this.loadRecords();
          this.recordform.reset();
          this.$Progress.finish();
        })
        .catch(()=>{
          this.ErrorToast();
          this.$Progress.fail();
        })
      },
      updateRecord(){
        this.$Progress.start();
        this.recordform.put('/api/project/'+this.id+'/folder/'+this.recordform.id)
        .then((response) => {
          $('#addNewRecord').modal('hide');
          this.SuccessToast();
          this.loadRecords();
          this.recordform.reset();
          this.$Progress.finish();
        })
        .catch(() => {
          this.ErrorToast();
          this.$Progress.fail();
        });
      },
      deleteRecord(id){
        Swal.fire({
          title: 'Вы уверены?',
          text: "Это действие нельзя будет отменить",
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          cancelButtonText: 'Отмена',
          confirmButtonText: 'Да, удалить'
          }).then((result) => {
           if (result.value) {
            this.recordform.delete('/api/project/'+this.id+'/folder/'+id).then(()=>{
              this.SuccessToast();
              this.loadRecords();
            }).catch((data)=> {
              this.ErrorToast();
            });
          }
        })
      },
      loadRecords(){
        axios.get('/api/project/'+this.id+'/folder').then(({ data }) => {
          this.records = data;
        });
      }
    },
    created() {
      this.$Progress.start();
      this.loadRecords();
      this.$Progress.finish();
    }
  }
</script>
